import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text, TextInput } from '@/components/common/text';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_SPACING, REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { SURVEY_LIMITS } from '@/constants/residents/corkBoardConstants';

interface Props {
  prompt: string;
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

export const LongTextQuestionView: React.FC<Props> = ({
  prompt,
  value,
  onChange,
  maxLength = SURVEY_LIMITS.longTextDefaultMaxLength,
}) => {
  const { colors } = useThemeColors();
  const overLimit = value.length > maxLength * 0.9;

  return (
    <View style={styles.root}>
      <Text scale="content" style={[REDESIGN_TYPOGRAPHY.cardTitle, { color: colors.text.primary }]}>{prompt}</Text>
      <TextInput
        multiline
        value={value}
        onChangeText={(t) => onChange(t.slice(0, maxLength))}
        maxLength={maxLength}
        style={[
          styles.input,
          REDESIGN_TYPOGRAPHY.body,
          {
            color: colors.text.primary,
            borderColor: colors.card.border,
            backgroundColor: colors.card.bg,
          },
        ]}
        placeholder="Type your answer…"
        placeholderTextColor={colors.text.tertiary}
      />
      <Text
        style={[
          REDESIGN_TYPOGRAPHY.small,
          styles.counter,
          { color: overLimit ? colors.accent.red : colors.text.tertiary },
        ]}
      >
        {value.length} / {maxLength}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  root: { gap: REDESIGN_SPACING.sectionGap },
  input: {
    borderWidth: 1,
    borderRadius: REDESIGN_SPACING.buttonRadius,
    padding: 12,
    minHeight: 140,
    textAlignVertical: 'top',
  },
  counter: { textAlign: 'right' },
});
